import { Button, Heading, Paragraph } from '@/components/atoms';
import StorefrontIllustration from '@/assets/svg/storefront.svg?react';
import { Plus } from 'lucide-react';

interface ProductsEmptyStateProps {
  onAddProduct: () => void;
}

export const ProductsEmptyState = ({
  onAddProduct,
}: ProductsEmptyStateProps) => {
  return (
    <div className="flex min-h-[420px] flex-col items-center justify-center rounded-xl border bg-white px-6 py-16 text-center">
      <StorefrontIllustration className="mb-8 h-36 w-36 opacity-80" />
      <div className="mx-auto flex max-w-lg flex-col items-center gap-3">
        <Heading size="xl">Let&apos;s add your first product!</Heading>
        <Paragraph size="sm" className="text-muted-foreground">
          Build your catalog one product at a time, or import many at once with
          our spreadsheet template.
        </Paragraph>
        <Button className="mt-4" onClick={onAddProduct}>
          <Plus />
          Add Product
        </Button>
      </div>
    </div>
  );
};
